import type { ButtonVariant } from './types.ts';

export const getVariant = ({
  primary,
  secondary,
  critical,
  ghost,
}: {
  primary: boolean | undefined;
  secondary: boolean | undefined;
  critical: boolean | undefined;
  ghost: boolean | undefined;
}): ButtonVariant => {
  if (primary) return 'primary';
  if (secondary) return 'secondary';
  if (critical) return 'critical';
  if (ghost) return 'ghost';
  return 'primary';
};
